import LeaderBadge from './LeaderBadge'

export default LeaderBadge
